import { get, isEmpty, join, map, sumBy } from 'lodash'

export const centsToDollars = (cents) => {
  let result = `$${(Math.abs(cents) / 100).toFixed(2)}`
  if (cents < 0) result = `-${result}`

  return result
}

export const toFixed = (number, digits) => {
  const regex = /^[0]{0,}\./
  let result = number
  if (parseInt(number) !== number) {
    result = parseFloat(number.toFixed(digits))
  }

  return result.toString().replace(regex, '.')
}

export const formatCartItemModifiers = (modifierItems, notes) => {
  const modifierStrings = map(modifierItems, (modifierItem) => {
    const name = get(modifierItem, 'name', '')
    const priceInCents = get(modifierItem, 'defaultPriceInCents', 0)

    if (priceInCents > 0) {
      return `${name} +$${(priceInCents / 100).toFixed(2)}`
    } else {
      if (modifierItem.price) {
        const priceInCents = stringFloatToCents(modifierItem.price)
        if (priceInCents > 0) {
          return `${name} + $${modifierItem.price}`
        }
      }
      return name
    }
  })

  let result = join(modifierStrings, ', ')

  if (!isEmpty(result) && !isEmpty(notes)) result += '. '
  if (!isEmpty(notes)) result += notes

  return result
}

export const displayCartItemPrice = (cartItem, modifiers) => {
  const basePrice = get(cartItem, 'defaultPriceInCents', 0)
  const modifierPrice = sumBy(modifiers, (mod) => get(mod, 'defaultPriceInCents', 0))
  const price = basePrice + modifierPrice

  return `$${(centsToFloat(price))}`
}

export const displayPreOrdersItemPrice = (cartItem, modifiers) => {
  const basePrice = get(cartItem, 'price', "0.00")
  const priceInCents = stringFloatToCents(basePrice)

  var totalModPrice = 0
  modifiers.forEach(mod => {
    if (mod.price) {
      totalModPrice += stringFloatToCents(mod.price)
    }
  })

  const price = priceInCents + totalModPrice

  return `$${(price  / 100).toFixed(2)}`
}

/**
 *
 * @param {string} dollarAmount the formatted dollar amount
 * @description
 * This method takes in a string and removes all non-numeric values to output
 * the amount in cents.
 * @example
 * stringFloatToCents('$5.50') // 550
 */
export const stringFloatToCents = (stringFloat) => {
  // The leading negative shouldn't be removed, as it is part of the value.
  const isNegative = (stringFloat && stringFloat?.length != 0) ? (stringFloat.trim().charAt(0) == '-') : false
  const multiplier = isNegative ? -1 : 1

  return multiplier * parseInt(stringFloat?.replace?.(/\D/g,'') ?? 0)
}

export const centsToFloat = (cents) => (cents / 100).toFixed(2)

export const lowercaseCapitalizeFirst = (string) => string ? string.trim().toLowerCase().split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ') : ''
